import { createAction, createAsyncAction } from "typesafe-actions";
import type { FetchError } from "app/pages/sales-intelligence/types";
import type { ExportSettingWithType, ExportNotification, ExportSetting, HubspotExportSettings } from "../../type";
import type { IntegrationStatusResponse } from "../../../components/types";

export const fetchExportSettingsTableAsync = createAsyncAction(
    "@@si/management/hubspot/manage-export/FETCH_EXPORT_SETTINGS_START",
    "@@si/management/hubspot/manage-export/FETCH_EXPORT_SETTINGS_SUCCESS",
    "@@si/management/hubspot/manage-export/FETCH_EXPORT_SETTINGS_FAILURE",
)<void, ExportSettingWithType, FetchError>();

export const fetchHsExportSettingsAsync = createAsyncAction(
    "@@si/hubspot-export/FETCH_HS_EXPORT_SETTINGS_START",
    "@@si/hubspot-export/FETCH_HS_EXPORT_SETTINGS_SUCCESS",
    "@@si/hubspot-export/FETCH_HS_EXPORT_SETTINGS_FAILURE",
)<void, HubspotExportSettings, FetchError>();

export const saveExportSettingsAsync = createAsyncAction(
    "@@si/management/hubspot/manage-export/SAVE_EXPORT_SETTINGS_START",
    "@@si/management/hubspot/manage-export/SAVE_EXPORT_SETTINGS_SUCCESS",
    "@@si/management/hubspot/manage-export/SAVE_EXPORT_SETTINGS_FAILURE",
)<void, ExportSettingWithType, FetchError>();

export const addNewSettingsExport = createAction(
    "@@si/management/hubspot/manage-export/ADD_NEW_EXPORT_SETTINGS",
)<ExportSettingWithType>();

export const updateHsSettingsExport = createAction(
    "@@si/management/hubspot/manage-export/UPDATE_EXPORT_SETTINGS",
)<ExportSettingWithType>();

export const deleteSettingExport = createAction(
    "@@si/management/hubspot/manage-export/DELETE_EXPORT_SETTING",
)<ExportSettingWithType>();

export const revertSettingsExport = createAction(
    "@@si/management/hubspot/manage-export/REVERT_EXPORT_SETTING",
)<ExportSettingWithType>();

export const setHsEditableField = createAction("@@si/management/hubspot/manage-export/SET_EDITABLE_FIELD")<
    ExportSetting | undefined
>();

export const setHsDeletableField = createAction("@@si/management/hubspot/manage-export/SET_DELETABLE_FIELD")<
    ExportSetting | undefined
>();

export const setSelectedSalesForceFields = createAction("@@si/management/hubspot/manage-export/SET_SELECTED__FIELD")<
    Record<string, boolean>
>();

export const exportDomainsToAsync = createAsyncAction(
    "@@si/management/hubspot/manage-export//EXPORT_DOMAINS_SALES_FORCE_START",
    "@@si/management/hubspot/manage-export//EXPORT_DOMAINS_SALES_FORCE_SUCCESS",
    "@@si/management/hubspot/manage-export//EXPORT_DOMAINS_SALES_FORCE_FAILURE",
)<void, void, FetchError>();

export const showModalDisabledExport = createAction(
    "@@si/management/hubspot/manage-export/SHOW_MODAL_DISABLED_EXPORT_",
)<boolean>();

export const setHsNotification = createAction(
    "@@si/management/hubspot/manage-export/SET_NOTIFICATION",
)<null | ExportNotification>();

export const getCompaniesStatusAsync = createAsyncAction(
    "@@si/management/hubspot/manage-integration/GET_COMPANIES_STATUS_START",
    "@@si/management/hubspot/manage-integration/GET_COMPANIES_STATUS_SUCCESS",
    "@@si/management/hubspot/manage-integration/GET_COMPANIES_STATUS_FAILURE",
)<void, boolean, FetchError>();

export const putCompaniesStatusAsync = createAsyncAction(
    "@@si/management/hubspot/manage-integration/PUT_COMPANIES_STATUS_START",
    "@@si/management/hubspot/manage-integration/PUT_COMPANIES_STATUS_SUCCESS",
    "@@si/management/hubspot/manage-integration/PUT_COMPANIES_STATUS_FAILURE",
)<void, IntegrationStatusResponse, FetchError>();

export const putContactsToggleAsync = createAsyncAction(
    "@@si/management/hubspot/manage-integration/PUT_CONTACTS_STATUS_START",
    "@@si/management/hubspot/manage-integration/PUT_CONTACTS_STATUS_SUCCESS",
    "@@si/management/hubspot/manage-integration/PUT_CONTACTS_STATUS_FAILURE",
)<void, IntegrationStatusResponse, FetchError>();

export const saveHsAllSettingsError = createAction(
    "@@si/management/hubspot/manage-export/SAVE_ALL_SETTINGS_ERROR",
)<string>();
